export enum HotelStatus {
  Draft = 'draft',
  Published = 'published',
  TestMode = 'test_mode',
}
